import { AxiosError } from 'axios'

import type { ApiError, ToApiError } from '@/lib/apiError'
import { BadRequestError, GenericApiError } from '@/lib/apiError'

export const toApiError: ToApiError = (error: unknown): ApiError => {
  if (error instanceof AxiosError) {
    if (error?.response?.status === 400) {
      return new BadRequestError([])
    }
  }

  return new GenericApiError()
}
